import { Tooltip as MuiTooltip, TooltipProps } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

interface Props extends TooltipProps {
  className?: string;
}

const TooltipImpl = React.forwardRef<HTMLElement, Props>(
  ({ className, ...props }, ref) => {
    return <MuiTooltip className={className} ref={ref} {...props} />;
  }
);

/**
 * Customized MUI Tooltip component.
 *
 * It inherits all properties of a MUI Tooltip
 */
export const Tooltip = muiStyled(TooltipImpl)(({ theme }) => css``);

export default Tooltip;
